var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"addVcnSystem section-main__warp"},[_c('div',{staticClass:"addVcnForm"},[_c('ioc-form',{attrs:{"option":_vm.addVcnOption},on:{"submit":_vm.submit,"reset-change":_vm.cancelBtn},model:{value:(_vm.addVcnData),callback:function ($$v) {_vm.addVcnData=$$v},expression:"addVcnData"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }